import { Button, Grid } from "@mui/material";
import React from "react";
import { useSuperAdminUserRole } from "../../../../context/SuperAdmin/UserRoleContext";
import { useAuthContext } from "../../../../hooks/Auth";

const HeadersUsersRole = () => {
  const { toggleDeleteModal, toggleAddModal, toDeleteUsers } =
    useSuperAdminUserRole();
  const { canAccess } = useAuthContext();
  return (
    <Grid container spacing={4} display={"flex"} justifyContent={"flex-end"}>
      {canAccess("delete:roleUsers") && (
        <Grid item>
          <Button
            variant="outlined"
            onClick={() => toggleDeleteModal(true)}
            disabled={!toDeleteUsers.length}
            sx={{
              borderRadius: 14,
              border: "1px solid #336B87",
              color: "#336B87",
              "&:hover": {
                backgroundColor: "#336B87",
                color: "#EEF3F6",
              },
            }}
          >
            Eliminar
          </Button>
        </Grid>
      )}
      {canAccess("create:roleUsers") && (
        <Grid item>
          <Button
            variant="contained"
            onClick={() => toggleAddModal(true)}
            sx={{ background: "#336B87" }}
          >
            Agregar Usuarios
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default HeadersUsersRole;
